import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormControlComponent } from '../form-control.component';
import { Observable } from 'rxjs';
import { FilterResult } from '../../../repository.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FormControl } from '../form-control.model';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-form-control-checkboxlist-user-face',
  templateUrl: './form-control-checkboxlist-user-face.component.html',
  styleUrls: ['./form-control-checkboxlist-user-face.component.scss']
})

export class FormControlCheckboxlistUserFaceComponent extends FormControlComponent implements OnInit {
	@Input()
	from: any;

	public saveFrom;

	@Input()
	label: string;

	@Input()
	value = 'id';

	@Input()
	detailButton = false;

	@Input()
	inline = false;

	@Input()
	disabled = false;

	@Input()
	displaySelectAll = false;

	@Input()
	canSelect = true;

	items: FilterResult<any>;
	options = [];
	selected = [];

	public searchControl: any;
	public resultComment: boolean;
	constructor(private translate: TranslateService) {
		super();
	}

	ngOnInit() {
		this.saveFrom = null;
		this.searchControl = new FormControl("searchControl")
		this.selected = this.control.value || [];
		this.control.valueChanges.subscribe((value) => {
			this.selected = value || [];
		});
		this.resultComment = false;

		this.searchControl.valueChanges.subscribe(ret =>{
			this.resultComment = false;
			this.saveFrom  = JSON.stringify(this.from);
			this.saveFrom = JSON.parse(this.saveFrom);
			if(ret != null && ret!=''){
				let localOrga = [];
				this.saveFrom.forEach(orga => {
					let holdOrga = true
					if(orga.n.indexOf(ret) == -1 && orga.n.toUpperCase().indexOf(ret.toUpperCase()) == -1){
						//On dessend dans la hierarchie pour voir si les écrans des localisation ne peuvent pas correspondre;
						
							
							let holdLocation = true;
							//Pas de traitement de nom de localisation
							let localFace = [];
							orga.f.forEach( face =>{
								face.hold = true;
								if(face.sc.indexOf(ret) == -1 && face.sc.toUpperCase().indexOf(ret.toUpperCase()) == -1){
									face.hold = false;
								}
								else{
									localFace.push(face);
								}
							})
							orga.f = localFace;
							if(orga.f.length !=0){
								localOrga.push(orga);
							}
					}
					else{
						//On ne fait rien, on garde l'orga et tous les éléments en dessous
					}
				});
				this.saveFrom = localOrga;
				if(this.saveFrom.length == 0){
					//afficher un truc pour dire que pas de résultat
					this.resultComment = true;
				}
			}
			else{
			}
		})
	}
	
	changeSearchValue(ret:any){
		this.resultComment = false;
		this.saveFrom  = JSON.stringify(this.from);
		this.saveFrom = JSON.parse(this.saveFrom);
		if(ret != null && ret!=''){
			let localOrga = [];
			this.saveFrom.forEach(orga => {
				let holdOrga = true
				if(orga.o.indexOf(ret) == -1 && orga.o.toUpperCase().indexOf(ret.toUpperCase()) == -1){
					//On dessend dans la hierarchie pour voir si les écrans des localisation ne peuvent pas correspondre;
					//Pas de traitement de nom de localisation
					let orgFace = [];
					orga.f.forEach( face =>{
						face.hold = true;
						if(face.sc.indexOf(ret) == -1 && face.sc.toUpperCase().indexOf(ret.toUpperCase()) == -1){
							face.hold = false;
						}
						else{
							orgFace.push(face);
						}
					})
					orga.f = orgFace;
					if(orga.f.length !=0){
						localOrga.push(orga);
					}
				}
				else{
					localOrga.push(orga);
					//On ne fait rien, on garde l'orga et tous les éléments en dessous
				}
			});
			this.saveFrom = localOrga;
			if(this.saveFrom.length == 0){
				//afficher un truc pour dire que pas de résultat
				this.resultComment = true;
			}
		}
		else{
		}
	}

	checkChanged(evt: MatCheckboxChange) {
		if (evt.checked) {
			const elmt = evt.source.value;

			this.selected.push(elmt);
		} else {
			const pos = this.position(evt.source.value);
			if (pos > -1) {
				this.selected.splice(pos, 1);
			}
		}
		this.control.setValue(this.selected);
	}

	// checkAll() {
	// 	for (let i = 0; i < this.items.items.length; i++) {
	// 		const item = this.items.items[i];
	// 		const pos = this.position(item[this.value]);
	// 		if (pos < 0) {
	// 			const elmt = item[this.value];
	// 			this.selected.push(elmt);
	// 		}
	// 	}
	// }

	// uncheckAll() {
	// 	for (let i = 0; i < this.items.items.length; i++) {
	// 		const item = this.items.items[i];
	// 		const pos = this.position(item[this.value]);
	// 		if (pos >= 0) {
	// 			this.selected.splice(pos, 1);
	// 		}
	// 	}
	// }

	selectOrganization(id: number, $event: any){
		this.from.forEach(org => {
			if(org.id == id){
				org.f.forEach(face =>{
					if($event.checked == true){
						let index = this.selected.indexOf(face.id);
						if(index == -1){
							this.selected.push(face.id);
						}
					}
					else{
						let index = this.selected.indexOf(face.id);
						this.selected.splice(index, 1);
					}
				})
				//Sélection de tous les écranen dessous si canSelectScreen
			}
		});
	}

	position(id): number {
		for (let idx = 0; idx < this.selected.length; idx++) {
			if (this.selected[idx] == id) {
				return idx;
			}
		}

		return -1;
	}


}
